import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Spinner from '../UI/Spinner/Spinner';
import { changeTopic, saveColors, setTopic } from '../../actions/actions';
import { shuffle, generateRandomColor } from '../../helpers';
import Topic from '../Topic/Topic';

// let TFMATRIXUSERRPC = window.TFMATRIXUSERRPC;
// TFMATRIXUSERRPC = {ajax_url: "http://delta.mylearningmyway.com/wp-admin/admin-ajax.php", security: "6c492ff866"};

const jQuery = window.jQuery;

class TopicList extends Component {
	state = {
		showSpinner: true,
		allBlocks: []
	};

	storeBlocksLocation = currentTopicId => {     // storing the location of blocks to localStorage
		this.props.topicList.map(topic => {
			if (topic.id === currentTopicId) window.localStorage.setItem(`${this.props.currentApp}-blocks-${topic.id}`, JSON.stringify(topic.blocks));
			return null;    // or React will bitch about returning a value
		});
	}

	resetBlocksLocation = currentTopicId => {   // removing the location of blocks from localStorage
		this.props.topicList.map(topic => {
			if (topic.id === currentTopicId) window.localStorage.removeItem(`${this.props.currentApp}-blocks-${topic.id}`);
			return null;
		});
	}

	componentDidMount() {
		jQuery("#colophon").hide();
		jQuery(".entry-header").hide();
		jQuery(".site-header").hide();

		this.createData();
	}

	createData = () => {
		let dataFile = 'App1Data.json';
		if (this.props.currentApp === 'app-2') dataFile = 'App2Data.json';
		if (this.props.currentApp === 'app-3') dataFile = 'App3Data.json';

		fetch(`/wp-content/plugins/terabit-matrix-game/assets/data/${dataFile}`)
		.then(response => response.json())
		.then(data => {
			let savingBlocks = [];  // to save ALL 100 blocks (for app-3) instead of just 25
			const dataValues = Object.values(data);

			let topicNumber = dataValues.length;
			let totalQuizQuestionNumber = 26;
			let baseQuestionNumberForEachTopic = Math.floor(totalQuizQuestionNumber / topicNumber);
			let quizQuestionsRemainder = totalQuizQuestionNumber % topicNumber;

			dataValues.map((topic, index) => {
				if (topic.selected) {   // if this topic is selected (from the drop-down menu). 1st one is selected by default
					topic.isPlaying = false;
					this.props.setTopic({ selectedTopic: topic });
					this.props.changeTopic({
						topics: dataValues,
						selectedTopicId: parseInt(topic.id)
					});
				}

				if (this.props.currentApp === 'app-3') {
					const shuffledBlocks = [...shuffle(topic.blocks)]
					let questionNumberForQuiz = baseQuestionNumberForEachTopic + (index < quizQuestionsRemainder ? 1 : 0);
					for(let k = 0; k<questionNumberForQuiz; k++){
						savingBlocks.push({...shuffledBlocks[k], theme: index});
					}
					topic.blocks = [];
					if (topic.selected) this.props.saveColors({ topicColors: generateRandomColor(this.props.currentApp, topic.title) });
					shuffledBlocks.map((block, index) => {
						if (index < 25) topic.blocks.push(block)    // only getting the first 25 random blocks
						return null;    // so that React doesn't bitch about returning a value
					});
				} else {
					// when the page loads, IF we have a saved sequence for this topic, we will get locations of blocks from localStorage
					if (window.localStorage.getItem(`${this.props.currentApp}-topic-${topic.id}-1`)) {   // IF there is a sequence saved for this topic
						if (window.localStorage.getItem(`${this.props.currentApp}-blocks-${topic.id}`)) {
							topic.blocks = JSON.parse(window.localStorage.getItem(`${this.props.currentApp}-blocks-${topic.id}`));   // getting the location of blocks from localStorage
						}
					} else topic.blocks = shuffle(topic.blocks);    // ELSE shuffle the blocks
					this.props.saveColors({ topicColors: generateRandomColor(this.props.currentApp) });
				}
				return null;    // you know why
			});

			shuffle(savingBlocks);
			console.log({savingBlocks});
			if (data) this.setState({ allBlocks: savingBlocks, showSpinner: false })
		}).catch(err => console.log('Data loading failed.', err));
	}

	startNewQuiz = () => {
		this.createData();
		console.log("startNewQuiz");
	}

	render() {
		let renderCondition = !this.state.showSpinner;
		if (this.props.currentApp === 'app-3') renderCondition = !this.state.showSpinner && this.state.allBlocks.length > 0;
		const topicList = (
			renderCondition ?
			this.props.topicColors && this.props.topicList.filter(topic => topic.selected).map((topic, index) => (
				<Topic key={index} id={index}
			       spinnerState={this.state.showSpinner}
				   closeApp={() => this.props.closeApp()}
		           closeAppButtonDisabled={status => this.props.closeAppButtonDisabled(status)}
                   setBlocksLocation={currentTopicId => this.storeBlocksLocation(currentTopicId)}
                   resetBlocksLocation={currentTopicId => this.resetBlocksLocation(currentTopicId)}
                   allBlocks={this.state.allBlocks}
                   startNewQuiz={() => this.startNewQuiz()}
				/>
			))
			: null
		);

		return (
			<Fragment>
				{this.state.showSpinner ? <Spinner /> : null}
				{topicList}
			</Fragment>
		);
	}
}

TopicList.propTypes = {
	topics: PropTypes.array,
	topicList: PropTypes.array,
	changeTopicState: PropTypes.func
};

const mapStateToProps = state => ({
	currentApp: state.appReducer.currentApp,
	selectedTopicId: state.topicListReducer.selectedTopicId,
	topicColors: state.topicListReducer.topicColors,
	topicList: state.topicListReducer.topics || [],
});

const mapDispatchToProps = dispatch => ({
	changeTopic: params => dispatch(changeTopic(params)),
	saveColors: params => dispatch(saveColors(params)),
	setTopic: params => dispatch(setTopic(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TopicList)